import plural from '../../../shared/format';

const attrs2month = {
  '1MonthReturnPercent': 1,
  '3MonthReturnPercent': 3,
  '6MonthReturnPercent': 6,
  '1YearReturnPercent': 12,
  '2YearReturnPercent': 24,
  '3YearReturnPercent': 36,
  '5YearReturnPercent': 60,
  '10YearReturnPercent': 120,
};

const month2Label = m => {
  if (m === undefined) {
    return '';
  }
  if (m < 12) {
    return `${m} Month${plural(m)}`;
  }
  const y = Math.floor(m / 12);
  return `${y} Year${plural(y)}`;
};

export {
  attrs2month,
  month2Label,
};
